'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OFFSET_CLASSES = exports.SIZE_CLASSES = exports.SCREEN_SIZES = exports.SIZE_RANGE = exports.OFFSET_RANGE = exports.MIN_SIZE = exports.MIN_OFFSET = exports.MAX_SIZE = exports.MAX_OFFSET = undefined;

var _range = require('../utils/underscore/range');

var _range2 = _interopRequireDefault(_range);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAX_OFFSET = exports.MAX_OFFSET = 12;
var MAX_SIZE = exports.MAX_SIZE = 12;
var MIN_OFFSET = exports.MIN_OFFSET = 0;
var MIN_SIZE = exports.MIN_SIZE = 1;
var OFFSET_RANGE = exports.OFFSET_RANGE = (0, _range2.default)(MIN_OFFSET, MAX_OFFSET + 1);
var SIZE_RANGE = exports.SIZE_RANGE = (0, _range2.default)(MIN_SIZE, MAX_SIZE + 1);

var SCREEN_SIZES = exports.SCREEN_SIZES = ['xs', 'sm', 'md', 'lg', 'xl'];

function createSizeClasses(screenSize) {
  var classes = {};
  for (var i = MIN_OFFSET; i <= MAX_SIZE; i++) {
    if (i === 0) {
      classes[i] = '';
    } else {
      classes[i] = 'col-' + screenSize + '-' + i;
    }
  }
  return classes;
}

function createAllSizeClasses() {
  var append = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var holdScreenClasses = {};
  SCREEN_SIZES.forEach(function (screenSize) {
    holdScreenClasses[screenSize] = createSizeClasses('' + screenSize + append);
  });
  return holdScreenClasses;
}

var SIZE_CLASSES = exports.SIZE_CLASSES = createAllSizeClasses();
var OFFSET_CLASSES = exports.OFFSET_CLASSES = createAllSizeClasses('-offset');


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/grid/UIGridConstants.js
// module id = 710
// module chunks = 3 4